// src/components/Rectangle.js
import React from 'react';
import { useSpring, animated } from '@react-spring/web';
import PropTypes from 'prop-types';

const Rectangle = ({ x, y, width, height, theme }) => {
    const springProps = useSpring({
        to: { x, y, width, height },
        config: { friction: 30 },
    });

    return (
        <animated.rect
            x={springProps.x}
            y={springProps.y}
            width={springProps.width}
            height={springProps.height}
            fill={theme.palette.primary.main}
            fillOpacity={0.3}
            stroke={theme.palette.primary.dark}
            strokeWidth={1}
        />
    );
};

Rectangle.propTypes = {
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    theme: PropTypes.object.isRequired,
};

export default Rectangle;
